import sanitizeHtml from 'sanitize-html';

export function sortByTimestamp(a, b) {
  if ( a.timestamp < b.timestamp ){
    return -1;
  }
  if ( a.timestamp > b.timestamp ){
    return 1;
  }
  return 0;
}

export function sortById(a, b) {
  if (a.id < b.id) return -1
  if (a.id > b.id) return 1
  return 0
}

/**
 * Подготовка сообщения к выводу
 * @param msg
 * @returns {string|boolean|*}
 */
export function prepareMessage(msg) {
  msg = cleanMessage(msg)
  msg = replaceHashtags(msg)

  return msg
}

/**
 * Очистка от html
 * @param msg
 * @returns msg
 */
export function cleanMessage(msg) {
  return sanitizeHtml(msg, {
    allowedTags: [ 'img' ]
  });
}

/**
 * Замена эмоджи
 * @param msg
 * @returns {*}
 */
export function replaceEmojy(msg) {
  const replacements = {
    ":)": "🙂", ":-)": "🙂", "=)": "🙂", "=-)": "🙂",
    ":(": "😞", ":-(": "😞", "=(": "😞", "=-(": "😞",
    ";)": "😉", ";-)": "😉",
    ":|": "😐", ":-|": "😐",
    ":'(": "😢", ":'-(": "😢",
    ":O": "😮", ":-O": "😮", ":o": "😮", ":-o": "😮",
    ":P": "😛", ":-P": "😛", ":p": "😛", ":-p": "😛",
    ":-*": "😘", ":*": "😘",
    "*.*": "😍",
    ";-P": "😜",
    "8)": "😎", "8-)": "😎",
    ":D": "😄", ":-D": "😄", "=D": "😃", "=-D": "😃"
  }
  Object.keys(replacements).forEach(k => {
    msg = msg.replace(k, replacements[k])
  })

  return msg
}

/**
 * Замена стикеров
 * @param msg
 * @param src
 * @returns {string|boolean}
 */
export function replaceSticker(msg, src) {
  const replacements = {
    ":shark-1:": "sticker-1.svg",
    ":shark-2:": "sticker-2.svg",
    ":shark-3:": "sticker-3.svg",
    ":shark-4:": "sticker-4.svg",
    ":shark-5:": "sticker-5.svg",
    ":shark-6:": "sticker-6.svg",
    ":shark-7:": "sticker-7.svg",
    ":shark-8:": "sticker-8.svg",
    ":shark-9:": "sticker-9.svg",
    ":shark-10:": "sticker-10.svg",
    ":shark-11:": "sticker-11.svg",
    ":shark-12:": "sticker-12.svg",
  }
  if (msg in replacements) {
    return `${src}${replacements[msg]}`
  }

  return false
}

/**
 * Замена хештегов
 * @param msg
 * @returns {*}
 */
export function replaceHashtags(msg) {
  return msg.replace("#вопрос", '<span class="hashtag">#вопрос</span>')
      .replace("#авария", '<span class="hashtag">#авария</span>')
      .replace("#нмо", '<span class="hashtag">#нмо</span>')
}
